import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authReducer";
import signupReducer from "./signupSlice";
import activeLoginReducer from "./activeLoginSlice";
import profileReducer from "./profileSlice"
import workflowReducer from "./workflowListSlice"
import companyDetailReducer from "./companyDetails";
import pdfEditorTokenReducer from "./pdfEditorTokenSlice"
import uploadDocumentReducer from "./uploadDocumentSlice";
import signerReducer from "./signerSlice";
import meonUserReducer from "./meonUserSlice"
import productReducer from './productSlice';
// pdfeditor slices
import loginReducer from "./pdfeditor/loginSlice";
import flagReducer from "./pdfeditor/flagSlice";
import registerReducer from "./pdfeditor/registerSlice";
import passwordSlice from "./pdfeditor/passwordSlice";
import dashboardSlice from "./pdfeditor/dashboardSlice";
import sentSlice from "./pdfeditor/sentSlice";
import auditTrailSlice from "./pdfeditor/auditTrailSlice";
import pdfSlice from "./pdfeditor/pdfSlice";
import profileSlice from "./pdfeditor/profileSlice";
import reportsSlice from "./pdfeditor/reportsSlice";
import receivedSlice from "./pdfeditor/receivedSlice";
import receivedPDFSlice from "./pdfeditor/receivedPDFSlice";
import creditSlice from "./pdfeditor/creditSlice";
import superAdminSlice from "./pdfeditor/superAdminSlice";
import addCreditSlice from "./pdfeditor/addCreditSlice";
import addUserSlice from "./pdfeditor/addUserSlice";
import superAdminCreditSlice from "./pdfeditor/superAdminCreditSlice";
import postpaidBillPaymentSlice from "./pdfeditor/postpaidBillPaymentSlice";
import superAdminDashboardSlice from "./pdfeditor/superAdminDashboardSlice";
import changeAccountTypeSlice from "./pdfeditor/changeAccountTypeSlice";
import allCompanyDetailsSlice from "./pdfeditor/allCompanyDetailsSlice";
import pdfGenrateTokenSlice from "./pdfeditor/pdfGenrateTokenSlice";
import genrateEsignTokenWithDocumentIDSlice from "./pdfeditor/genrateEsignTokenWithDocumentIDSlice";

import pdfCoordinatesSlice from "./pdfeditor/pdfCoordinatesSlice";
import pageModificationSlice from "./pdfeditor/pageModificationSlice";
import pdfDetailsSlice from "./pdfeditor/pdfDetailsSlice";
import toolsModificationSlice from "./pdfeditor/toolsModificationSlice";
import insertPdfSlice from "./pdfeditor/insertPdfSlice";
import getDocumentsDetailSlice from "./pdfeditor/getDocumentsDetailSlice";
import getTemplateSlice from "./pdfeditor/getTemplateSlice";
import selectOptionsSlice from "./pdfeditor/selectOptionsSlice";
import previousDataSlice from "./pdfeditor/previousDataSlice";
import deletedImageSlice from "./pdfeditor/deletedImageSlice";
import singleClickSlice from "./pdfeditor/singleClickSlice";
import pdfAddedRemovedCoordSlice from "./pdfeditor/pdfAddedRemovedCoordSlice";
import addSignerSlice from "./pdfeditor/addSignerSlice";


const store = configureStore({
  reducer: {
    auth: authReducer,
    activeLogin: activeLoginReducer,
    signup: signupReducer,
    profile: profileReducer,
    companydetail: companyDetailReducer,
    workflow: workflowReducer,
    pdfEditortoken: pdfEditorTokenReducer,
    uploadDocument: uploadDocumentReducer,
    signers: signerReducer,
    meonUsers: meonUserReducer,
    products: productReducer,
    // pdfeditor slices
    login: loginReducer,
    flag: flagReducer,
    register: registerReducer,
    password: passwordSlice,
    dashboard: dashboardSlice,
    sent: sentSlice,
    audit: auditTrailSlice,
    pdf: pdfSlice,
    profile: profileSlice,
    report: reportsSlice,
    received: receivedSlice,
    receivedPDF: receivedPDFSlice,
    credit: creditSlice,
    superAdmin: superAdminSlice,
    addCredit: addCreditSlice,
    addUser: addUserSlice,
    superAdminCredit: superAdminCreditSlice,
    postpaidBillPayment: postpaidBillPaymentSlice,
    superAdminDashboard: superAdminDashboardSlice,
    changeAccountType: changeAccountTypeSlice,
    allCompanyDetails: allCompanyDetailsSlice,
    pdfGenrateToken: pdfGenrateTokenSlice,
    genrateEsignTokenWithDocumentID: genrateEsignTokenWithDocumentIDSlice,
    
    pdfCoordinates: pdfCoordinatesSlice,
    pageModification: pageModificationSlice,
    pdfDetails: pdfDetailsSlice,
    toolsModification: toolsModificationSlice,
    insertPdf: insertPdfSlice,
    getDocumentsDetail: getDocumentsDetailSlice,
    getTemplate: getTemplateSlice,
    selectOptions: selectOptionsSlice,
    addSigner: addSignerSlice,
    previousData: previousDataSlice,
    deletedImage: deletedImageSlice,
    singleClickSl: singleClickSlice,
    pdfAddremoved: pdfAddedRemovedCoordSlice, 
  },
});

export default store;
